// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_H-z","twoColumnImage":"aI-z"};